// ===================================================================
// KAIXO - CRMReports
// ===================================================================
// Vista 'reports' del CRM: estadísticas agregadas (KPIs + breakdown
// por fuente + breakdown por agente con ratio de conversión).
// ===================================================================

import React from 'react';
import ct from './i18n';

export default function CRMReports({ reports }) {
    if (!reports) return <p className="crm-center">{ct.loading}</p>;

    return (
        <>
            <div className="crm-kpis">
                <div className="crm-kpi">
                    <div className="crm-kpi-val">{reports.total}</div>
                    <div className="crm-kpi-label">{ct.total}</div>
                </div>
                <div className="crm-kpi">
                    <div className="crm-kpi-val" style={{ color: '#059669' }}>{reports.converted}</div>
                    <div className="crm-kpi-label">{ct.converted}</div>
                </div>
                <div className="crm-kpi">
                    <div className="crm-kpi-val" style={{ color: '#EF4444' }}>{reports.lost}</div>
                    <div className="crm-kpi-label">{ct.lost}</div>
                </div>
                <div className="crm-kpi">
                    <div className="crm-kpi-val">${(reports.totalBudget || 0).toLocaleString()}</div>
                    <div className="crm-kpi-label">{ct.revenue}</div>
                </div>
            </div>

            <h4 className="crm-section-title">{ct.bySource}</h4>
            <div className="crm-report-bars">
                {Object.entries(reports.bySource || {}).map(([source, count]) => (
                    <div key={source} className="crm-bar-row">
                        <span className="crm-bar-label">{ct.sources?.[source] || source}</span>
                        <div className="crm-bar">
                            <div
                                className="crm-bar-fill"
                                style={{ width: `${Math.min(100, (count / (reports.total || 1)) * 100)}%` }}
                            />
                        </div>
                        <span className="crm-bar-val">{count}</span>
                    </div>
                ))}
            </div>

            <h4 className="crm-section-title">{ct.byAgent}</h4>
            <div className="crm-report-bars">
                {Object.entries(reports.byAgent || {}).map(([agent, data]) => (
                    <div key={agent} className="crm-bar-row">
                        <span className="crm-bar-label">{agent}</span>
                        <div className="crm-bar">
                            <div
                                className="crm-bar-fill"
                                style={{
                                    width: `${Math.min(100, (data.converted / (data.total || 1)) * 100)}%`,
                                    background: '#059669'
                                }}
                            />
                        </div>
                        <span className="crm-bar-val">{data.converted}/{data.total}</span>
                    </div>
                ))}
            </div>
        </>
    );
}
